import { render, staticRenderFns } from "./ColorSelectorExt.vue?vue&type=template&id=095380ba&scoped=true"
import script from "./ColorSelectorExt.vue?vue&type=script&lang=js"
export * from "./ColorSelectorExt.vue?vue&type=script&lang=js"
import style0 from "./ColorSelectorExt.vue?vue&type=style&index=0&id=095380ba&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095380ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('095380ba')) {
      api.createRecord('095380ba', component.options)
    } else {
      api.reload('095380ba', component.options)
    }
    module.hot.accept("./ColorSelectorExt.vue?vue&type=template&id=095380ba&scoped=true", function () {
      api.rerender('095380ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/shapeAttr/ColorSelectorExt.vue"
export default component.exports